import React from 'react';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import { Modal, Button } from 'antd';
import exit from "@/assets/icons/exit.png";
import './index.scss';

export default function ModalExit({ closeModal }) {
  const { instance } = useMsal();

  function logout() {
    localStorage.clear();
    instance.logoutRedirect({
      postLogoutRedirectUri: '/',
    });
  }

  return (
    <>
      <AuthenticatedTemplate>
        <Modal
          open={true}
          onCancel={() => closeModal(false)}
          footer={null}
          centered
        >
          <div className="modalContainer">
            <div className="title">
              <img src={exit} alt="Exit" />
            </div>
            <div className="body">Are you sure want to logout?</div>
            <div className="footer">
              <Button className="no" onClick={() => closeModal(false)}>
                No, Just kidding
              </Button>
              <Button className="yes" type="primary" onClick={() => logout()}>
                Yes, Log me out
              </Button>
            </div>
          </div>
        </Modal>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div className="modalBackground">
          <div className="modalContainer">
            <div className="body">You are not Authenticated</div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </>
  );
}
